//import Libraries
import React from 'react'
import PropTypes from 'prop-types';
import path from 'path';

//import Components

//import Style classes
import './Button.css';

//NEEDS UPDATE!!
const button = (props) => {
    // console.log("[Button.js]", props)
    let buttonStyle = {
        height: props.height ? props.height : "",
        backgroundColor: props.color ? props.color : "var(--highlight-color)"
    }
    buttonStyle = {...buttonStyle, ...props.style}
    const defaultHandler = () => {
        if(props.link) {
            document.location.href = path.resolve(props.link);
        }
    }
    return(
        <div
            className='GlobalButton'
            onClick={props.clickHandler ? props.clickHandler : defaultHandler}
            style={buttonStyle}>
            <h4>{props.name[props.language]}</h4>
        </div>
    );
}

button.propTypes = {
    name: PropTypes.object.isRequired,
    language: PropTypes.string.isRequired,
    clickHandler: PropTypes.func,
    link: PropTypes.string
  };

export default button;


// WEBPACK FOOTER //
// ./src/components/Button/Button.js